import type { RootState } from '@/store';

export const selectEscritorioMembros = (state: RootState) => state.escritorioMembros.membros;
export const selectEscritorioMembrosCarregadoPara = (state: RootState) =>
  state.escritorioMembros.loadedEscritorioId;
